import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ListChecked"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 6H22.5V7.5H12V6ZM4.5 7.9425L2.5575 6L1.5 7.0575L4.5 10.0575L10.5 4.0575L9.4425 3L4.5 7.9425ZM12 16.5H22.5V18H12V16.5ZM4.5 18.4425L2.5575 16.5L1.5 17.5575L4.5 20.5575L10.5 14.5575L9.4425 13.5L4.5 18.4425Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ListChecked.vue"]]);
